import { IconButtonProps } from '../types';

// To Do. Implement
const useViewModel = (props: IconButtonProps) => props;

export { useViewModel };
